import { render, staticRenderFns } from "./PayRights.vue?vue&type=template&id=135aeebc&scoped=true&lang=pug"
import script from "./PayRights.vue?vue&type=script&lang=js"
export * from "./PayRights.vue?vue&type=script&lang=js"
import style0 from "./PayRights.vue?vue&type=style&index=0&id=135aeebc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135aeebc",
  null
  
)

export default component.exports